var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-12" }, [
      _vm.status === "" || _vm.status === "ABERTO"
        ? _c("p", { staticClass: "text-right" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-outline btn-group",
                attrs: { href: "#" },
                on: { click: _vm.enviarPedido }
              },
              [
                _c("i", { staticClass: "fas fa-chart-bar" }),
                _vm._v(" Gerar Relatóri")
              ]
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-12" },
      [
        _vm.totalItensSelecionados > 0
          ? _c(
              "p",
              {
                staticClass: "text-left",
                staticStyle: { "margin-bottom": "0px" }
              },
              [
                _c("strong", { staticClass: "text-primary" }, [
                  _vm._v("Pedidos Selecionados: ")
                ]),
                _vm._v(_vm._s(_vm.enviar.length) + "\n            "),
                _c("strong", { staticClass: "text-primary" }, [_vm._v(" | ")]),
                _vm._v(" "),
                _c("strong", { staticClass: "text-primary" }, [
                  _vm._v("Itens Selecionados: ")
                ]),
                _vm._v(_vm._s(_vm.totalItensSelecionados) + "\n        ")
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("v-table", {
          attrs: {
            column: _vm.colunas,
            data: _vm.dataTable,
            actions: _vm.actionsTable
          },
          on: {
            change: _vm.changeQtdItensSelecionados,
            markAll: _vm.changeMarcarTodos,
            show: _vm.showPedido,
            edit: _vm.editPedido
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e20c72ac", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e20c72ac","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/relatorio/Pedidos.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-e20c72ac","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/relatorio/Pedidos.vue
// module chunks = 2